import { useTranslation } from "react-i18next";
import InvoicesItem from "../../components/InvoicesItem/InvoicesItem";
import MenuItemHeader from "../../components/MenuItemHeader/MenuItemHeader";
import styles from "./Invoices.module.scss";
import MobileInvoiceCard from "../../components/MobileInvoiceCard/MobileInvoiceCard";
import { useGetInvoicesQuery } from "../../store/services/details-api";
import LoaderCard from "../../components/Loader/LoaderCard";
import ErrorCard from "../../components/ErrorCard/ErrorCard";
import { useEffect } from "react";
import { trackEvent } from "../../utils/analytics";
import { EVENT_NAMES } from "../../types/event-names";
import PaymentManagement from "./PaymentManagement";

const InvoicesPage = () => {
  const { data, error, isLoading } = useGetInvoicesQuery(null);

  const { t } = useTranslation();

  useEffect(() => {
    trackEvent(EVENT_NAMES.SCREEN_INVOICES_VIEWED, { screen_name: "Invoices" });
  }, []);

  return (
    <div className={styles.root}>
      <div className={styles.root_mobile}>
        <MenuItemHeader page={t("Invoices")} subtitle={t("Download and manage invoices.")} />
      </div>

      <div className={styles.root_desktop}>
        <MenuItemHeader page={t("Invoices")} subtitle={t("Access your billing history & download invoices")} />
      </div>
      {isLoading ? (
        <LoaderCard />
      ) : error ? (
        <ErrorCard text={t("Unable to load data. Please refresh the page or try again later.")} />
      ) : (
        data && (
          <>
            <h3 className={styles.root_title} style={{ marginTop: "35px" }}>{t("Payment Management")}</h3>
            <div className={styles.root_table}>
              <div className={styles.root_table_header}>
                <p className={styles.root_table_header_item}>{t("Transaction ID")}</p>
                <p className={styles.root_table_header_item}>{t("Date")}</p>
                <p className={styles.root_table_header_item}>{t("Product")}</p>
                <p className={styles.root_table_header_item}>{t("Price")}</p>
                <p className={styles.root_table_header_item}>{t("Download Invoice")}</p>
              </div>
              {data.map((item, index) => (
                <div key={index}>
                  <InvoicesItem
                    id={item.id}
                    date={item.date}
                    product={item.product}
                    price={item.price}
                    currency={item.currency}
                    receiptUrl={item.receiptUrl}
                  />
                </div>
              ))}
            </div>
            {data.map((item, index) => (
              <div key={index}>
                <MobileInvoiceCard id={item.id} date={item.date} product={item.product} price={item.price} />
              </div>
            ))}
          </>
        )
      )}

      {/* Payment Management */}
      <PaymentManagement />
    </div>
  );
};

export default InvoicesPage;
